import { Col, Row } from "react-bootstrap";
import { FieldArrayWithId, UseFieldArrayAppend, UseFieldArrayRemove, useFormContext } from "react-hook-form";
import { FaPlus } from "react-icons/fa6";
import { useState } from "react";
import SelectAsync from "shared/components/select/SelectAsync";
import { RetencoesYupSchemaDTO } from "types/dto/imposto/RetencoesYupSchemaDTO";
import { RetencoesForm } from "types/reactHookForm/formTypes/RetencoesForm";
import { retencaoMaiorQuePrimeiraParcela } from "shared/yup/schemas/CadastrarDespesaParceladaGroupPaySchema";
import LinhaRetencao from "./LinhaRetencao";

interface SecaoRetencaoModalCadastrarDespesaGroupPayProps {
  retencoes: any[];
  adicionarRetencao: any;
  removerRetencao: UseFieldArrayRemove;
  somaValorBruto: number;
  valorTotalImpostos: number;
  isParcelada?: boolean;
  condominioId: number;
}

type previousValueValorBase = {
  valorBase: number | undefined;
};

const SecaoRetencaoModalCadastrarDespesaGroupPay: React.FC<SecaoRetencaoModalCadastrarDespesaGroupPayProps> = (
  props
) => {
  const { control, register, watch, formState, setValue } = useFormContext<any>();

  const [previousValueValorBase, setPreviousValueValorBase] = useState<previousValueValorBase[] | undefined>();

  const criarRetencaoVazia = (): RetencoesYupSchemaDTO => ({
    imposto: null,
    valorBase: null,
    mesCompetencia: null,
    dataVencimento: null,
    valor: undefined,
    contribuinte: null,
    conta: null,
    formaPagamento: null,
    codigoDeBarras: "",
    anexo: null,
  });

  return (
    <>
      {props.retencoes.length > 0 && (
        <Row className="mb-3">
          <Col md={11}>
            <SelectAsync
              id="select-natureza-rendimento"
              label="Natureza do rendimento"
              name="naturezaRendimento"
              endpoint="/api/natureza-rendimento/buscar-registros-select-async"
              onChange={(e) => {
                (setValue as any)("naturezaRendimento", e)
              }}
              nomeAtributoLabel="descricao"
              nomeAtributoValue="id"
              usarValidacaoParaFormulario={true}
              control={control}
              register={register}
              setValue={setValue}
              isClearable={true}
            />
          </Col>
        </Row>
      )}

      {props.retencoes.map((retencao, index) => {
        return (
          <LinhaRetencao
            key={retencao.id}
            index={index}
            removerRetencao={props.removerRetencao}
            condominioId={props.condominioId}
            isParcelada={props.isParcelada}
          />
        );
      })}

      {(watch("classesConta" as any) as any)?.length === 1 && (
        <div
          onClick={() => {
            const newPrevious = [...(previousValueValorBase || []), { valorBase: props.somaValorBruto }];
            setPreviousValueValorBase(newPrevious);
            (props.adicionarRetencao as any)(criarRetencaoVazia());
          }}
          className="botao-adicionar-item-lista d-inline-block mt-3"
        >
          <FaPlus size={15} />
          <span className="ms-2">Adicionar retenção</span>
        </div>
      )}

      {props.retencoes.length > 0 && (
        <div className="mt-4 fw-bold d-flex flex-column align-items-start">
          <div>
            <span className="me-2">Valor total bruto (R$):</span>
            <span>{props.somaValorBruto.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</span>
          </div>
          <div>
            <span className="me-2">Valor total líquido (R$):</span>
            <span>
              {(props.somaValorBruto - props.valorTotalImpostos).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </span>
          </div>
        </div>
      )}

      {props.retencoes.length > 0 &&
        formState.isSubmitted &&
        formState.errors.retencoes?.message && (
          <div className="alert alert-danger mt-2 mb-0" role="alert">
            <i className="fa fa-exclamation-circle me-2" aria-hidden="true" />
            {typeof formState.errors.retencoes.message === "string"
              ? formState.errors.retencoes.message
              : props.isParcelada
                ? retencaoMaiorQuePrimeiraParcela
                : "O somatório dos valores informados para retenções não pode ser superior ao valor bruto total."}
          </div>
        )}
    </>
  );
};

export default SecaoRetencaoModalCadastrarDespesaGroupPay;
